import { render } from "./SampleRegistrationComponent.vue?vue&type=template&id=77ee2435"
import script from "./SampleRegistrationComponent.vue?vue&type=script&lang=js"
export * from "./SampleRegistrationComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__